import React from 'react'
import { Row, Col, Card, Button } from '@deere/ux.uxframe-react'

export const ViewResultsButton = ({filterDataOnClick}) => (
    <Card className="fixed-bottom position-sticky view-result">
        <Row className="align-items-center h-100">
            <Col md="24" className="col w-100 text-center">
                <Button
                    className="btn btn-primary btn-block"
                    style={{ marginRight: "auto" }}
                    onClick={filterDataOnClick}
                >
                    View Results
                </Button>
            </Col>
        </Row>
    </Card>
)